import { render, staticRenderFns } from "./TableAction.vue?vue&type=template&id=1826c20e&scoped=true&"
import script from "./TableAction.vue?vue&type=script&lang=ts&"
export * from "./TableAction.vue?vue&type=script&lang=ts&"
import style0 from "./TableAction.vue?vue&type=style&index=0&id=1826c20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1826c20e",
  null
  
)

export default component.exports